// extracted by mini-css-extract-plugin
export var featureColumn = "PermissionWidget-module--featureColumn--PaGj8";
export var field = "PermissionWidget-module--field--Nuw-X";
export var header = "PermissionWidget-module--header--kJ8Ee";
export var permColumn = "PermissionWidget-module--permColumn---PKYs";